const Items = [
  // Jobify //
  {
    id: 1,
    mainImage:
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/wfwrrnhb19hmjsxhxtnl.png",
    img: [
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/h9k1gttzkzb61lehc9o9.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/dcqwy2roibcvrcrdxjze.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/omghfia7ov8hlfp9snjd.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/wyjxms1f2o9rmi2zbbja.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/vkzv5c1z98ol0uqxms7n.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/gj2k0skedafyuzfhdllv.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/yq1z4rlcszq4ucmmrzo4.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/t0qdqa3nmtwmkomosg3z.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/l0onv5nj232egnglkybk.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/blbrutjx0kqcdrpbjwnl.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709013934/Projects/Jobify/wfwrrnhb19hmjsxhxtnl.png",
    ],
    features: [
      "Secure user registration, Login and Logout.",
      "Demo user: Application can be tried without registering.",
      "Dashboard: The application provides a dashboard with bar and area charts to visualize job application statistics.",
      "User can Adding, Editing, Deleting, Searching and Filtering his Jobs.",
      "Job Status and Types can be customized.",
      "User can Update his Info and setting his own picture.",
      "The Application is fully responsive with any screen sizes.",
      "Handles have been created for any kind of expected or unexpected errors.",
    ],
    technologies: [
      "MongoDB",
      "JavaScript",
      "React.js",
      "React Hooks",
      "React icons",
      "Node.js",
      "Express.js",
      "Chart.js",
      "Responsive Web Design",
      "CSS",
      "HTML",
      "Deployed on Render",
    ],
    title: "Jobify",
    description:
      "Jobify is a job tracking application built using the MERN (MongoDB, Express, React, Node.js) stack. The app allows users to track the status of their job applications. It is a valuable tool for job seekers looking to streamline their job search process.",
    category: "Full-Stack",
    liveLink: "https://jobify-4oft.onrender.com/",
    codeLink: "https://github.com/MucahidDeveloper/jobify/",
  },
  // Kanban Board //
  {
    id: 2,
    mainImage:
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709014431/Projects/MujKanbanBoard/og0injxpfrqopgfjh3yc.png",
    img: [
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709014431/Projects/MujKanbanBoard/miklazc9saqyupl2xtsp.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709014431/Projects/MujKanbanBoard/mhyzaddaz1upaqqvwgj8.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709014431/Projects/MujKanbanBoard/og0injxpfrqopgfjh3yc.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709014431/Projects/MujKanbanBoard/rzdqns5szdqnizytawvq.png",
    ],
    features: [
      "Add / Remove / Edait Tasks",
      "Move Tasks Between Lists (To Do - In Progress - Done) By Drag & Drop Listneres",
      "Apply Browser Local Storage to Save User Inputs (Tasks - Tasks Lists - Current Surah of The Quran Player)",
      "Full Quran Player made up fetching 'alquran.cloud' API and play it using Audio API of the Browser",
      "Breath Handler maded to relax user, maded By Animation features of CSS",
      "Showing Current Time And Date, Updating every second",
      "Errors handler on the console",
      "Responsive for all screen sizes",
    ],
    technologies: [
      "JavaScript (Pure)",
      "CSS",
      "HTML",
      "Restful API",
      "Browser Audio API",
      "CSS Animation",
      "Responsing Web Design",
      "Fetching alquran.cloud API",
      "rowser Local Storage",
    ],
    title: "Kanban Board",
    description:
      "Kanban board to manage and assign finished and in-progress tasks, created with pure JavaScript without any libraries or frameworks. The application also contains an API to play surahs of the Holy Qur’an while performing tasks, and Relaxer works with CSS animation for the user to relax during rest time.",
    category: "JavaScript",
    liveLink: "https://mujkanbanboard.netlify.app/",
    codeLink: "https://github.com/MucahidDeveloper/MyKnabanBoard",
  },
  // OminoFood
  {
    id: 3,
    mainImage:
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/szlermz8wyj55zyepqdr.png",
    img: [
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/kcvw5oyprthm76sj1ez2.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/c7e9qryzke8cjfd0enmy.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/sa0zw22lewz9dvfdstst.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/lcvztjaefbxzfpmsot7p.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/zvrhp4ncw4ydddnxbx8k.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/q66x07anwfoydxnmx7am.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/vuqfcnp0wfnkwl3tgb1b.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708968747/Projects/Ominofood/nqt1arv8laxgagejwc1a.png",
    ],
    features: [
      "Responsive Web Design to all Screen sizes",
      "Css Grid & Flex strongly used",
      "Comfortable Design",
      "Email Sending",
    ],
    technologies: [
      "HTML5",
      "CSS",
      "Responsive Web Design",
      "CSS Grid Layout",
      "UI & UX",
      "Front End Development",
      "Design to Code",
    ],
    title: "OminoFood",
    description:
      "Omnifood is a frontend project that showcases a fictional food delivery company that utilizes AI to prepare and deliver healthy meals. This landing page is designed to highlight the features and benefits of Omnifood, a smart 365-days-per-year food subscription service that is tailored to individual tastes and nutritional needs.",
    category: "HTML-CSS",
    liveLink: "https://ui-practice-ominofood.netlify.app/",
    codeLink: "https://github.com/MucahidDeveloper/ResturantLandPage",
  },
  // FaceRecognizeR
  {
    id: 4,
    mainImage:
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708969791/Projects/FaceRecognizer/yitwq5quobv3ty1iaudc.png",
    img: [
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708969791/Projects/FaceRecognizer/yitwq5quobv3ty1iaudc.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708969791/Projects/FaceRecognizer/ix8ccnpprhwpd2e8fp1t.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708969791/Projects/FaceRecognizer/akpnhanl0uuyiga3ivqh.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1708969791/Projects/FaceRecognizer/xiyudmtguvh1gy3qcsnr.png",
    ],
    features: [
      "Register & Login",
      "Accept Image URLS and recognize any faces in it",
      "Can Recognize any number of faces within the image",
      "REcognize faces of humans, animals, anime and any kind of alians!",
      "Background maded of Particals using React Labrary",
      "A moving Logo using React Labrary",
      "Server Error handling",
      "Secure data transfeer through hashing",
      "Recognizing image happing through the power of AI API of Clarifi",
      "Responsive Design",
    ],
    technologies: [
      "React JS",
      "Node JS",
      "Express JS",
      "MySQL",
      "PJAdmin",
      "Fetch API",
      "JavaScript",
      "CSS",
      "Nodemon",
      "Many React Labraries",
      "Full-Stack Development",
    ],
    title: "Faces Recognizer",
    description:
      "This application accept image urls and uses AI power of Clarifai group to detect human faces within the image, also counts how much pictures you put in there. It got a simple React.js FrontEnd and a node.js/express backend with PostgreSQL as a database for the login.",
    category: "Full-Stack",
    liveLink: "https://muc-facerecognizer-app.onrender.com/",
    codeLink: "https://github.com/MucahidDeveloper/faceRecognizerApp",
  },
  // Aydinlatma
  {
    id: 5,
    mainImage:
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709011242/Projects/Aydinlatma/txixiv1bvmthnhern8j7.png",
    img: [
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709011242/Projects/Aydinlatma/d8dgycbiv0lnngvfmwbv.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709011242/Projects/Aydinlatma/htot5drundr57ryzwfhj.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709011242/Projects/Aydinlatma/c29txji7e3va3jcryicf.png",
      "https://res.cloudinary.com/dlq3ddecx/image/upload/v1709011242/Projects/Aydinlatma/txixiv1bvmthnhern8j7.png",
    ],
    features: [
      "Calculating the number of bulbs needed to light any place in a construction project",
      "Any existing data can be used and the calculation will be done, because there are 3 different ways to deal with the data depending on the amount of data",
      "The basic data and important values calculated, along with the result, are included in the lighting table",
      "Enables printing of lighting table",
      "Tables of values for lamp luminance by type and power, opacity factor, and location index for each calculation method, all converted to objects in JSON format (the JSON file was converted to JavaScript as requested by the supervising professor)",
      "If there is no value for the location index in the data table: the relative value corresponding to the index is calculated by analyzing the rest of the table data",
    ],
    technologies: [
      "JavaScript",
      "CSS",
      "HTML",
      "PrintJS",
      "Lighting calculation methods",
      "JSON",
      "E&E Engineering",
    ],
    title: "İç Aydınlatma Yöntemler",
    description:
      "A project programmed at the request of the professor of electrical lighting, according to his customized requests and according to the lighting schedules approved in Turkey. The number of bulbs required to ideally illuminate the place is calculated using 3 different methods according to the type of data and in proportion to the type of bulb used.",
    category: "JavaScript",
    liveLink: "https://aydinlatma-mucahid.netlify.app/",
    codeLink: "https://github.com/MucahidDeveloper/AydinlatmaProject",
  },
  // Appie
  // {
  //   id: 6,
  //   mainImage: "https://res.cloudinary.com/.png",
  //   img: ["https://res.cloudinary.com/"],
  //   features: [
  //     "Mobile Responsive",
  //     "Beautiful Animations",
  //     "Product",
  //     "Pricing",
  //     "Testimonial",
  //     "Contact",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Framer Motion",
  //     "React Icons",
  //     "React Hooks",
  //   ],
  //   title: "",
  //   description: "",
  //   category: "",
  //   liveLink: "",
  //   codeLink: "https://github.com/MucahidDeveloper",
  // },
  // // Car Agency
  // {
  //   id: 7,
  //   mainImage: "https://res.cloudinary.com/.png",
  //   img: ["https://res.cloudinary.com/"],
  //   features: [
  //     "Mobile Responsive",
  //     "Beautiful Animations",
  //     "Product",
  //     "Pricing",
  //     "Testimonial",
  //     "Contact",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Framer Motion",
  //     "React Icons",
  //     "React Hooks",
  //   ],
  //   title: "",
  //   description: "",
  //   category: "",
  //   liveLink: "",
  //   codeLink: "https://github.com/MucahidDeveloper",
  // },
  // // MERN Notes
  // {
  //   id: 8,
  //   mainImage: "https://res.cloudinary.com/.png",
  //   img: ["https://res.cloudinary.com/"],
  //   features: [
  //     "Mobile Responsive",
  //     "Beautiful Animations",
  //     "Product",
  //     "Pricing",
  //     "Testimonial",
  //     "Contact",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Framer Motion",
  //     "React Icons",
  //     "React Hooks",
  //   ],
  //   title: "",
  //   description: "",
  //   category: "",
  //   liveLink: "",
  //   codeLink: "https://github.com/MucahidDeveloper",
  // },
];

export default Items;
